import Index from '@/views/index.vue'
import NewsDetail from '@/views/newsDetail.vue'
import Register from '@/views/register.vue'
import RegisterCheck from '@/views/registerCheck.vue'
import Ask from '@/views/ask.vue'
import AskListM from '@/views/askListM.vue'
import AsksDetail from '@/views/asksDetail.vue'
import AskNoAuth from '@/views/askNoAuth.vue'
import AskCheck from '@/views/askCheck.vue'
export default [{
  path: '/',
  name:'首页',
  component: Index
},
{
  path: '/newsDetail/:id',
  name:'详情',
  component: NewsDetail
},
{
  path: '/register',
  name:'加装意愿登记',
  component: Register
},
{
  path: '/ask',
  name:'在线咨询',
  component: Ask
},
{
  path: '/askListM',
  name:'我的咨询',
  component: AskListM
},
{
  path: '/asksDetail/:id',
  name:'详情',
  component: AsksDetail
},
{
  path: '/registerCheck',
  name:'查询登记意愿',
  component: RegisterCheck
},
{
  path: '/askNoAuth',
  name:'在线咨询',
  component: AskNoAuth
},
{
  path: '/askCheck',
  name:'咨询查询',
  component: AskCheck
}
]
